module.exports = __webpack_public_path__ + "static/media/invoice.21762262.pdf";